<template>
  <div>
    <validation-observer v-slot="{ handleSubmit }">
      <v-card>
        <template v-if="errorMessage">
          <v-alert
                  type="error"
          >
            {{ errorMessage }}
          </v-alert>
        </template>
        <v-card-title class="text-sm-left font-weight-bold">
          Thêm lịch làm việc
          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="closeDialog"
          >
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="px-6">
          <v-row>
            <v-col
              cols="12"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Chọn nhân viên"
                rules="required"
              >
                <common-select-user
                  v-model="schedule.users"
                  :items="groupUsers"
                  color="primary"
                  item-text="fullName"
                  item-value="id"
                  multiple
                  clearable
                  search-input="Tìm kiếm hoặc chọn nhân viên"
                  label="Chọn nhân viên"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-menu
                ref="datePicker"
                v-model="datePicker"
                :close-on-content-click="false"
                :return-value.sync="schedule.date"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Ngày làm việc"
                    :rules="{required: true, after: afterDate}"
                  >
                    <v-text-field
                      v-model="schedule.date"
                      color="primary"
                      label="Ngày làm việc *"
                      prepend-icon="mdi-calendar-outline"
                      readonly
                      :error-messages="errors"
                      v-on="on"
                    />
                  </validation-provider>
                </template>
                <v-date-picker
                  v-model="selectedDate"
                  color="secondary"
                  scrollable
                  :error-messages="errors"
                  :min="firstDayMonthNext()"
                  @change="$refs.datePicker.save(selectedDate); datePicker = false"
                />
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Ca làm việc"
                rules="required"
              >
                <v-autocomplete
                  v-model="schedule.shift"
                  attach
                  :items="shiftList"
                  :error-messages="errors"
                  item-text="text"
                  item-value="value"
                  label="Chọn ca làm việc *"
                  color="primary"
                  clearable
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      class="px-0 ma-0"
                    >
                      <v-avatar
                        class="s-shift"
                        left
                      >
                        <span
                          class="bg-schedule-title"
                          :style="{background: data.item.color}"
                        />
                      </v-avatar>
                      {{ data.item.text }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <v-row class="align-center">
                <v-col
                  cols="12"
                  md="2"
                >
                  Lặp lại
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-radio-group v-model="schedule.repeat">
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-radio
                          label="Không lặp"
                          class="mt-0"
                          value="none"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-radio
                          label="Cả tuần"
                          class="mt-0"
                          value="weekly"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-radio
                          label="Cả tháng"
                          class="mt-0"
                          value="monthly"
                        />
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-0 group-btn--form">
          <v-btn
            color="success"
            @click.prevent="handleSubmit(createSchedule)"
          >
            Lưu lại
          </v-btn>
          <v-btn
            class="ml-0"
            color="primary"
            @click="closeDialog"
          >
            Hủy bỏ
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </div>
</template>
<script>
  import TokenService from '../../helpers/token';
  import RepositoryFactory from '@/repositories/RepositoryFactory'
  import { shiftList } from '../../helpers/constants'
  const ScheduleRepository = RepositoryFactory.get('schedule')
  const moment = require('moment')

  export default {
    name: 'ScheduleForm',
    props: {
      groupUsers: {
        type: Array,
        default: () => ([]),
      },
      scheduleChoose: {
        type: Object,
         default: () => ({}),
      },
    },
    $_veeValidate: {
      validator: 'new',
    },
    data () {
      return {
        shiftList,
        datePicker: false,
        errors: [],
        schedule: {
          repeat: 'none',
        },
        selectedDate: this.firstDayMonthNext(),
        errorMessage: '',
      }
    },
    created() {
      if(this.scheduleChoose.userId) {
        this.schedule = {
          repeat: 'none',
          users: [this.scheduleChoose.userId],
          date: this.scheduleChoose.date,
        }
      }
    },
    computed: {
      afterDate (afterValue, value) {
        const lastDayOfMonth = moment().endOf('month').format("YYYY-MM-DD");
        if (this.isStaff() && !this.checkAuthorization('schedule_view_all') ) {
          return lastDayOfMonth;
        }
        return moment('1900-01-01').endOf('month').format("YYYY-MM-DD");
      }
    },
    methods: {
      firstDayMonthNext () {
        if (this.checkAuthorization('schedule_view_all')) {
          return;
        }
        if (this.isStaff()) {
          return moment().subtract(-1, 'months').startOf('month').format('YYYY-MM-DD')
        }
        return;
      },
      closeDialog () {
        this.schedule = {
          repeat: 'none',
        }
        this.errorMessage = ''
        Bus.$emit('close-schedule-form', {})
      },
      remove (item) {
        const index = this.schedule.users.indexOf(item.id)
        if (index >= 0) this.schedule.users.splice(index, 1)
      },
      async createSchedule () {
        const postData = {
          userIds: this.schedule.users,
          repeat: this.schedule.repeat === 0 ? '' : this.schedule.repeat,
          date: this.schedule.date,
          description: '',
          shift: this.schedule.shift,
        }
        this.$swal({
          title: 'Thêm lịch làm việc',
          text: 'Bạn có thực sự muốn thêm lịch làm việc ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            // const loader = this.$loading.show()
            this.appLoadingData(true)
            const response = await ScheduleRepository.create(postData)
            // loader.hide()
            this.appLoadingData(false)
            if (_.get(response, 'success', false)) {
              this.errorMessage = ''
              this.$swal({
                        title: 'Đã thêm thành công !',
                        confirmButtonText: 'Đồng ý',
                      },
              ).then(() => {
                Bus.$emit('create-schedule-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(response, 'message', ''),
              })
            }
          }
        })
      },
    },
  }
</script>
<style scoped>
  /deep/.v-subheader {
    font-weight: bold;
    font-size: 14px;
  }
  /deep/.v-list-item__subtitle {
    font-size: 12px;
  }
  /deep/.v-list-item__title {
    font-size: 13px;
  }
  /deep/.v-list-item__action {
    margin-right: 5px !important;
  }
</style>
